import React, { FunctionComponent, SVGProps } from 'react';

import styled from 'styled-components';

export interface VisaLogoProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const VisaLogo: FunctionComponent<VisaLogoProps> = ({
  className,
  ...props
}) => (
  <svg
    width="49"
    height="16"
    viewBox="0 0 49 16"
    className={className || ''}
    {...props}
  >
    <Path d="M23.72,.28l-2.48,15.49h-3.97L19.75,.28h3.97Zm8,6.21c-1.39-.71-2.24-1.19-2.24-1.91,.02-.66,.72-1.33,2.29-1.33,1.29-.03,2.24,.28,2.96,.59l.36,.16,.54-3.34c-.78-.31-2.02-.66-3.56-.66-3.92,0-6.68,2.11-6.7,5.12-.03,2.22,1.98,3.46,3.48,4.2,1.54,.76,2.06,1.25,2.06,1.93-.02,1.04-1.24,1.52-2.38,1.52-1.58,0-2.43-.25-3.72-.82l-.52-.25-.56,3.48c.93,.43,2.65,.81,4.43,.82,4.16,0,6.88-2.08,6.91-5.29,.02-1.76-1.04-3.11-3.33-4.22Zm17.28,9.28h-3.68s-.36-1.78-.47-2.32h-5.1c-.15,.41-.83,2.32-.83,2.32h-4.16L40.65,1.57c.41-1.01,1.13-1.29,2.07-1.29h3.07l3.2,15.49Zm-4.8-5.49c-.16-.77-.91-4.48-.91-4.48l-.28-1.33c-.2,.58-.54,1.52-.52,1.48,0,0-1.26,3.44-1.58,4.33h3.3ZM13.95,.28h0l-3.89,10.56-.42-2.14h0l-1.39-7.12c-.23-.99-.93-1.27-1.8-1.3H.07l-.07,.31c1.56,.4,2.95,.98,4.17,1.7l3.54,13.46h4.2L18.15,.28h-4.2Z" />
  </svg>
);

export default VisaLogo;

const Path = styled.path`
  fill: ${({ theme }) => theme.colors.primary};
`;
